<ul class="ultima-menu ultima-main-menu clearfix" rte="14z">
    <ng-container *ngIf="!isMenuBlocked; else twoFactorRequiredBlock">
        <ng-container *ngFor="let item of app.menuModel; let i = index">
            <li *ngIf="!item.hidden" ultima-menu-item [item]="item" [index]="i" [root]="true" rte="14B"></li>
        </ng-container>

        <ng-container *ngIf="(app.formIoLoading | async) === false">
            <ng-container *ngFor="let item of app.formIoMenuModel; let i = index">
                <li *ngIf="!item.hidden" ultima-menu-item [item]="item" [index]="i" [root]="true"></li>
            </ng-container>
        </ng-container>
    </ng-container>

    <ng-template #twoFactorRequiredBlock>
        <p class="two-factor-disabled-message" rte="1dw">You don't have 2-Factor authentication enabled to access this features</p>
    </ng-template>
</ul>

<formio-filtered-form-select-dialog
    *ngIf="app.displaySelectFormDialog"
    [visible]="app.displaySelectFormDialog"
    [categories]="[app.currentFormModule.name]"
    [currentEpisode]="app.currentEpisode"
    [isHomePage]="true"
    (onSelect)="app.formSelected($event)"
    (onCancel)="app.displaySelectFormDialog = false" >
</formio-filtered-form-select-dialog>  

<formio-select-episode-dialog
    *ngIf = "app.displaySelectEpisodeDialog"
    [episodeRequired] = "app.episodeRequired"
    [patientId] ="app.patientService.currentPatientId"
    [restoreSelectControlState] = "app.restoreSelectControlState"
    [restoreDuplicateCheakState] = "app.restoreDuplicateCheakState"
    [episode] = "app.currentEpisode"
    (onSkip) = "app.onSkipOkEpisodeSelectDialog($event)"
    (viewEpisode) = "app.viewEpisode()"
    (onCancel) = "app.onCancelEpisodeSelectDialog()">
</formio-select-episode-dialog>

<multi-user-form-create-instance-dialog
   *ngIf = "app.displayMufCreateInstanceDialog"
    [episodeId]="app.currentEpisode ? app.currentEpisode.id: null"
    [patientId] ="app.patientService.currentPatientId"
    [multiUserFormDef] ="app.currentMUFDef"
    (onCancel)= "app.onCancelCreateInstanceDialog()"
    (onCreate)= "app.onCreateInstanceDialog($event)">
</multi-user-form-create-instance-dialog> 

<formio-select-patient-dialog *ngIf="app.displaySelectPatientDialog"
                              (onOk) = "app.onOkSelectPatientDialog($event)" 
                              (onCancel) ="app.displaySelectPatientDialog = false">
</formio-select-patient-dialog>

<formio-form-request-dialog
    *ngIf= "app.displayNewFormRequestDialog"
    [patientId] = "app.patientService.currentPatientId"
    [formRevisionId] = "app.currentFormDef.activeRevision.id"
    [episodeId]= "app.currentEpisode?.id"
    (onCancel)= "app.onCancelFormRequestDialog()"
    (onCreate)= "app.onCreateFormRequestDialog()">
</formio-form-request-dialog> 




